<template>
    <header class="address vcard">
            <section>
                <a class="url profile" href="/CV.pdf" target="_blank" rel="me author">CV</a>
                <a class="url profile" href="https://www.linkedin.com/in/mariopedroqueiros" target="_blank" rel="me author">LinkedIn</a>                
                <a class="email" href="mailto:mariopqueiros@gmail.com" title="Hangouts">mariopqueiros@gmail.com</a>
                <h2></h2>
                <br />
                <h1>
                    <a class="fn n url" id="resname" href="https:www.marioqueiros.com/" rel="me" title="Homepage">Mario Queiros</a>
                </h1>
                <meta content="Male">
                <meta content="Developer">
                <img src="../assets/img/mario.png" alt="Mario Queirps" class="mario-image">
            </section>
        </header>
</template>

<script>
export default{
    name: 'Header'
}
</script>